export const LIB_VERSION = '16.0.8'; // autogenerated
//# sourceMappingURL=version.js.map